import { createSlice, Slice } from '@reduxjs/toolkit';

export type ShopType = {
  id: number | null;
  name: string;
  code?: string;
  agentName?: string;
  minStake: number;
  maxStake: number;
  currency: string;
  /** Shop till / float (admin tops up). Customer wallet deposit debits till; customer wallet withdraw credits till. */
  tillBalance: number;
};

const initialState: ShopType = {
  id: null,
  name: '',
  code: '',
  agentName: '',
  minStake: 1,
  maxStake: 0,
  currency: 'Br',
  tillBalance: 0,
};

const shopSlice: Slice<ShopType> = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    setShop: (state, { payload }) => {
      Object.keys(payload).forEach((key) => {
        (state as Record<string, unknown>)[key] = (payload as Record<string, unknown>)[key];
      });
    },
    creditTill: (state, { payload }: { payload: { amount: number } }) => {
      const n = Number(payload.amount);
      if (!Number.isFinite(n) || n <= 0) return;
      state.tillBalance = (state.tillBalance ?? 0) + n;
    },
    debitTill: (state, { payload }: { payload: { amount: number } }) => {
      const n = Number(payload.amount);
      if (!Number.isFinite(n) || n <= 0) return;
      state.tillBalance = Math.max(0, (state.tillBalance ?? 0) - n);
    },
  },
});

// eslint-disable-next-line operator-linebreak
export const { setShop, creditTill, debitTill } = shopSlice.actions;
export default shopSlice.reducer;
